// float tone should be in range from -0.6 to 0.6
// float background should be in range from -0.6 to 0.6
export const adjustLevels = `
vec3 adjustTone(vec3 color, float levelsTone, float levelsBrightness) {
  vec3 levelMinimum = vec3(levelsTone);
  vec3 levelMiddle = vec3(1);
  vec3 levelMaximum = vec3(1.0 - levelsBrightness);
  vec3 minOutput = vec3(0);
  vec3 maxOutput = vec3(1);
  
  vec3 outColor = mix(
  minOutput,
  maxOutput,
  pow(
    min(
      max(color - levelMinimum, vec3(0.0)) / (levelMaximum - levelMinimum),
      vec3(1.0)
    ),
    1.0 / levelMiddle
  ));
  
  return outColor;
}
`;
